import React, { useState } from "react";
import PropTypes from "prop-types";
import placeholder from "../assets/img/placeholder.png";
import "../styles/data-display/badge.scss";
function Badge({
  src,
  initials,
  alt = "",
  size = "md",
  type = "round",
  statusIcon = null,
  status = null,
}) {
  const [imgError, setImgError] = useState(false);
  const showImage = src && !imgError;

  const classes = [
    "rm-badge",
    `rm-badge-${size}`,
    `rm-badge-${type}`,
    status ? `rm-badge-status rm-status_${status}` : null,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={classes}>
      {showImage ? (
        <img
          className="rm-badge-image"
          src={src}
          alt={alt}
          onError={() => setImgError(true)}
        />
      ) : initials ? (
        <span
          className="rm-badge-initials t-avatar-initials"
          aria-label={alt || undefined}
        >
          {initials}
        </span>
      ) : (
        <img
          className="rm-badge-image"
          src={placeholder}
          alt="Default avatar"
        />
      )}
      {statusIcon && (
        <div className="rm-badge-icon material-icons">{statusIcon}</div>
      )}
    </div>
  );
}

Badge.propTypes = {
  src: PropTypes.string,
  initials: PropTypes.string,
  alt: PropTypes.string,
  size: PropTypes.oneOf(["sm", "md", "lg"]),
  type: PropTypes.oneOf(["square", "round"]),
  statusIcon: PropTypes.node,
};

export default Badge;
